import React, { useState, Component } from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Loan from '../../Loan';
import LoanApproved from '../../Loan/LoanApproved';
import LoanApplication from 'views/pages/Loan/LoanApplication';
import LoanCompleted from 'views/pages/Loan/LoanCompleted';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box >{children} </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));


export default function SimpleTabs(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [opened, setOpened] = React.useState(false);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const togglemenu = (e) => {
        setOpened(!opened);
     }
    return (
      <div className={classes.root} style={{alignItems:"center"}}>
        <AppBar position="static" style={{background:"#ffffff"}}>
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" 
            color="white" indicatorColor="primary" textColor="primary">
            <Tab label="Awaiting Loans" {...a11yProps(0)} />
            <Tab label="Approved Loans" {...a11yProps(1)} />
            <Tab label="Completed Loans" {...a11yProps(2)} />
            <Tab label="Loan Application" {...a11yProps(3)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <Loan/>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <LoanApproved/>           
        </TabPanel>
        <TabPanel value={value} index={2}>
          <LoanCompleted/>           
        </TabPanel>
        <TabPanel value={value} index={3}>
          <LoanApplication/>           
        </TabPanel>
      </div>
    );
  }
  